import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export function useGetIsArielEmployee() {
    return useQuery('mo-users-for-organization', () => new Client().organization_GetIsArielEmployee(), {
        refetchOnWindowFocus: false
    });
}